import {
  KYOTO_REPRESENTATIVE_CAMPAIGN_START_DATE,
  KYOTO_REPRESENTATIVE_LIMIT,
  KYOTO_REPRESENTATIVE_WARNING_COUNT,
} from "../config";
import type { AppEnv } from "../libs/utils";

export type RepresentativeCampaignReceiveMethod = "self" | "family";

const representedSubscriptionIdJwtStorageKey =
  "kyoto-representative-campaign-represented-subscription-id-jwt";

export type UserRepresentationLike = {
  representUserId: string;
  representedUserId: string;
};

export function setRepresentedSubscriptionIdJwtForRepresentativeCampaign(
  jwt: string,
) {
  sessionStorage.setItem(representedSubscriptionIdJwtStorageKey, jwt);
}

export function getRepresentedSubscriptionIdJwtForRepresentativeCampaign() {
  return sessionStorage.getItem(representedSubscriptionIdJwtStorageKey);
}

export function clearRepresentedSubscriptionIdJwtForRepresentativeCampaign() {
  sessionStorage.removeItem(representedSubscriptionIdJwtStorageKey);
}

export function isSelfRepresentation(representation: UserRepresentationLike) {
  return representation.representUserId === representation.representedUserId;
}

export function getRepresentativeCampaignState({
  represent,
  represented,
}: {
  represent: UserRepresentationLike[];
  represented?: UserRepresentationLike;
}) {
  const representedCount = represent.filter(
    (representation) => !isSelfRepresentation(representation),
  ).length;

  return {
    selfApplied: represent.some(isSelfRepresentation) || represented != null,
    representedCount,
    shouldWarnRepresentedCount:
      representedCount >= KYOTO_REPRESENTATIVE_WARNING_COUNT,
    reachedRepresentedLimit: representedCount >= KYOTO_REPRESENTATIVE_LIMIT,
  };
}

export function canShowKyotoRepresentativeCampaign({
  tenantSlug,
  cityAddress,
  currentTime,
  appEnv,
}: {
  tenantSlug: string;
  cityAddress: string;
  currentTime: Date;
  appEnv: AppEnv;
}) {
  if (tenantSlug !== "kyoto-kyoto") {
    return false;
  }

  if (!cityAddress.startsWith("京都府京都市")) {
    return false;
  }

  if (appEnv !== "prod/live") {
    return true;
  }

  return currentTime >= KYOTO_REPRESENTATIVE_CAMPAIGN_START_DATE;
}
